/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellOffIcon20Solid = forwardRef('NotificationBellOffIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.707 1.293a1 1 0 0 0-1.414 1.414l3.115 3.115A5.985 5.985 0 0 0 4 8v3.795c0 .032-.01.063-.029.09l-1.746 2.457A1.05 1.05 0 0 0 3.081 16h11.505l2.707 2.707a1 1 0 0 0 1.414-1.414l-16-16Z" }),
        React.createElement("path", { d: "M16 8v3.732L7.045 2.777A6 6 0 0 1 16 8Z" }),
        React.createElement("path", { d: "M10 19.5A2.5 2.5 0 0 1 7.5 17h5a2.5 2.5 0 0 1-2.5 2.5Z" })));
});
